module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-operations/request-business-unit/request-business-unit.component.html
// module id = 1297
// module chunks = 10